import { gql } from "@apollo/client"

export const GET_COMPANY_STUDENTS = gql`
query GetCompanyStudents($id:UUID!){
  company(id:$id){
    students{
      id
      dob
    }
      sessionStats {
      __typename
      crisisSupportIndicated
      intensiveSupportIndicated
      supportIndicated
      preventionAndStrengthIndicated
      inTherapy
      hasRecentDeath
      beenBullied
    }
    companyActionHistory {
      referralsMade
      educationalMaterialsSent
    }
    companyStudentAgeFlags{
      ageAtSession
      assessmentData{
        feRisk  
        feProtective
        youRisk
        youProtective
        ace
        pce
        anxiety
        depression
        adhd
        suicidality
      }
      student{
        id
      }
    }
companyTopFlags{
    flagTitle
    flagId
    rankings{
      label
      total
      rank
    }
   }
  }
}`
